module.exports = __webpack_public_path__ + "img/nanotube-lv2.791eccd6.png";